<template>

    <crud-container :name="name">

        <crud-nav>
            <crud-nav-header title="Contacts" searchable="true"></crud-nav-header>

            <div class="grouping-key-container">
                <a v-for="(contactList,groupingKey) in items" @click.prevent="scrollContainerTo(groupingKey)" href="#">{{
                    groupingKey }}</a>
            </div>

            <crud-nav-scroll>
                <div class="grouped-item-listings" v-for="(contactList,groupingKey) in items">
                    <h2>{{ groupingKey }}</h2>
                    <span class="hide-me-please" :id="'item-list-group-heading-'+groupingKey"></span>
                    <ul>
                        <li class="items-list-item" :class="{active: isCurrentItem(contact) }"
                            v-for="contact in contactList">
                            <div class="name">
                                <a href="#" @click.prevent="getAndViewItemById(contact.id)">{{ contact.name }}</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-new>
                <crud-main-header title="Create New Contact" can-go-back-to-nav="true"></crud-main-header>

                <contacts-create></contacts-create>

            </crud-new>
            <crud-edit>
                <crud-main-header :title="'Editing: '+current_item.name" can-edit="true" can-go-back="true"
                                  :item="current_item"></crud-main-header>
                <crud-errors :errors="errors"></crud-errors>

                <dl>
                    <dt>Title</dt>
                    <dd><input type="text" v-model="current_item.title"/></dd>
                    <dt>First Name</dt>
                    <dd><input type="text" v-model="current_item.firstname"/></dd>
                    <dt>Last Name</dt>
                    <dd><input type="text" v-model="current_item.lastname"/></dd>
                    <div v-if="current_item.can_see_addresses">
                        <dt>Address</dt>
                        <dd><textarea v-model="current_item.address"></textarea></dd>
                        <dt>Postcode</dt>
                        <dd><input type="text" v-model="current_item.postcode"/></dd>
                    </div>
                    <dt>Email</dt>
                    <dd><input type="email" v-model="current_item.email"/></dd>
                    <dt>Phone</dt>
                    <dd><input type="text" v-model="current_item.phone"/></dd>
                    <dt>Phone (Secondary)</dt>
                    <dd><input type="text" v-model="current_item.secondary_phone"/></dd>
                    <dt>Replace Avatar</dt>
                    <dd><input type="file" ref="replaceAvatar"/></dd>
                </dl>

                <div class="action-button-group">
                    <a href="#" class="action-button action-button-dismiss" @click.prevent="backToItem()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                    </a>
                    <a href="#" class="action-button action-button-success" @click.prevent="saveItem()">
                        <i class="fa fa-check" aria-hidden="true"></i> Update Contact
                    </a>
                </div>


            </crud-edit>
            <crud-view>
                <crud-main-header :title="current_item.name" can-edit="true" can-go-back-to-nav="true"
                                  :item="current_item"></crud-main-header>

                <dl>
                    <dt>Name</dt>
                    <dd>{{ current_item.name }}</dd>
                    <div v-if="current_item.can_see_addresses">
                        <dt>Address</dt>
                        <dd>{{ current_item.address }}</dd>
                        <dt>Postcode</dt>
                        <dd>{{ current_item.postcode }}</dd>
                    </div>
                    <dt>Email</dt>
                    <dd><a :href="'mailto:'+current_item.email">{{ current_item.email }}</a></dd>
                    <dt>Phone</dt>
                    <dd><a :href="'tel:'+current_item.phone">{{ current_item.phone }}</a></dd>
                    <dt>Phone (Secondary)</dt>
                    <dd><a :href="'tel:'+current_item.secondary_phone">{{ current_item.secondary_phone }}</a></dd>
                </dl>
            </crud-view>
        </crud-main>

    </crud-container>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';

    export default {
        components: {
            InfiniteLoading,
        },
        data() {
            return {
                name: 'contacts',
                items: [],
                current_item: {},
                new_item: {},
                nextPaginationUrl: '',
                search_query: null,
                errors: null
            }
        },
        watch: {
            nextPaginationUrl: function () {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            }
        },
        computed: {
            has_query() {
                return this.search_query != '' && !_.isNull(this.search_query);
            }
        },
        methods: {
            isCurrentItem: function (item) {
                if (!("id" in this.current_item)) {
                    return false;
                }

                return item.id === this.current_item.id;
            },
            scrollContainerTo: function (key) {
                var $relevantElement = $("#item-list-group-heading-" + key);

                $('.crud-scroller').first().scrollTop(0);

                $('.crud-scroller').first().animate({
                    scrollTop: $relevantElement.offset().top - 180
                }, 500);
            },
            saveItem: function () {
                var that = this;
                var editingItem = $.extend({}, this.current_item);
                var formDataObject = new FormData();

                _.forIn(editingItem, function (value, key) {
                    formDataObject.append(key, value);
                });
                formDataObject.append('avatar', this.$refs.replaceAvatar.files[0]);
                formDataObject.append('_method', 'put');

                axios.request({
                    method: 'post',
                    url: appUrls.contacts.update.replace('REPLACEME', editingItem.id),
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {


                    _.forEach(this.items,function(itemList,groupedKey){
                        var indexOfItem = _.findIndex(itemList, function(contact){
                            return parseInt(contact.id,10) == parseInt(response.data.data.id,10);
                        });
                        that.items[groupedKey][indexOfItem] = response.data.data;
                    });

                    that.viewItem(response.data.data);
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },

            deleteItem(itemToDelete) {
                var that = this;
                var title = 'Are you sure you want to delete "' + itemToDelete.name + '"?';
                var description = 'Deleting this user is irreversible. Are you sure you want to delete it?';

                eventBus.$emit('delete-modal-open', title, description, function () {
                    that.activeItem = null;

                    let index = that.items.indexOf(itemToDelete);
                    that.items.splice(index, 1);

                    eventBus.$emit('crud-show-new-' + that.name);
                    axios.delete(appUrls.contacts.destroy.replace('REPLACEME', itemToDelete.id));
                    eventBus.$emit('crud-back-to-nav-' + that.name);
                });
            },
            resetErrors() {
                this.errors = null;
            },
            async getItems() {
                var that = this;
                var url = appUrls.contacts.index;
                var params = {};

                if (this.has_query) {
                    params.query = this.search_query;
                }

                params.group_by_letter = true

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        var hasGetVariable = location.search.indexOf('contact=') >= 0;
                        if (hasGetVariable) {
                            var idFromVariable = getParameterByName('contact');
                            if (fieldWithValueExistsInCollection(that.items, 'id', idFromVariable)) {
                                that.viewItem(getItemByFieldAndValue(that.items, 'id', idFromVariable));
                            } else {
                                that.getAndViewItemById(idFromVariable);
                            }
                        }
                    });
            },
            getAndViewItemById(id) {
                var that = this;
                var url = appUrls.contacts.show.replace('REPLACEME', id);

                axios.get(url)
                    .then(response => {
                        that.viewItem(response.data.data);
                    });
            },
            viewItem(item) {
                window.eventBus.$emit('crud-view-item-' + this.name, item);
            },
            backToNav: function () {
                window.eventBus.$emit('crud-back-to-nav-' + this.name);
            },
            backToItem: function () {
                window.eventBus.$emit('crud-back-' + this.name);
            }
        },
        mounted() {
            var that = this;
            this.getItems();
            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });
            window.eventBus.$on('crud-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

            window.eventBus.$on('crud-search-hidden-' + this.name, function (query) {
                that.search_query = null;
                that.getItems();
            });

            window.eventBus.$on('crud-edit-item-' + this.name, function (item) {
                this.new_item = {};
                this.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-delete-item-' + this.name, function (item) {
                that.deleteItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-view-item-' + this.name, function (item) {
                that.new_item = {};
                that.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-' + this.name, function (item) {
                that.current_item = item;
                that.viewItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-to-nav-' + this.name, function () {
                that.current_item = {};
                that.new_item = {};
                that.resetErrors();
            });

            window.eventBus.$on('item-created-'+this.name,function(contact){
                that.getItems();
                that.viewItem(contact);
            });
        }
    }
</script>

<style lang="scss" scoped>

</style>
